import * as React from 'react';
export const IcKey = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.71 16.71l-7.88-7.88c.112-.434.17-.881.17-1.33A5.5 5.5 0 107.5 13c.449 0 .896-.058 1.33-.17L10 14h2v2h2v2h2v2l.71.71a1 1 0 00.7.29H20a1 1 0 001-1v-2.59a1 1 0 00-.29-.7zM6.5 8a1.5 1.5 0 110-3 1.5 1.5 0 010 3z'
      fill='currentColor'
    />
  </svg>
);
